import { render, staticRenderFns } from "./ReceiptModal.vue?vue&type=template&id=2d550b71&"
import script from "./ReceiptModal.vue?vue&type=script&lang=js&"
export * from "./ReceiptModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports